<script lang="ts">
  import Button from "./Button.svelte";
  import cookie from "../assets/icons/cookie.svg";
  import Typography from "./Typography.svelte";
  import { TypographyType } from "../lib/constants/typographyMap";
  import * as cookiesHelper from "../lib/helpers/cookies";
  import { settingsStore } from "../lib/stores/settings";
  import { getCopy } from "../lib/stores/copy";
  import CookiePreferences from "./CookiePreferences.svelte";

  let isVisible = true;
  let arePreferencesVisible = false;

  const onAccept = () => {
    isVisible = false;
    cookiesHelper.accept();
  };

  const onDeny = () => {
    isVisible = false;
    cookiesHelper.deny();
  };

  const openPreferences = () => {
    isVisible = false;
    arePreferencesVisible = true;
  };

  const onPreferencesSaved = () => {
    arePreferencesVisible = false;
  };

  $: isVisible = !!cookiesHelper.checkVisibility($settingsStore);
  $: copy = $getCopy("gdpr") as Record<string, string>;
</script>

<CookiePreferences isVisible={arePreferencesVisible} on:save={onPreferencesSaved} />
{#if isVisible}
  <div
    class="overlay fixed flex flex-col lg:flex-row bottom-6 left-0 bg-white z-10 rounded-2xl lg:rounded-full justify-between overflow-hidden lg:p-0 lg:pr-3 p-3 pr-3 items-center gap-3">
    <div class="flex w-full lg:w-2/3">
      <div class="hidden min-[375px]:block bg-[--color-purple-50] rounded-full w-20 h-20">
        <img class="w-20 h-20" src={cookie} alt="cookie" />
      </div>
      <div class="flex flex-1 items-center text-[--color-grayscale-black] min-[375px]:ml-4">
        <Typography mobile={TypographyType.Headline3Medium} desktop={TypographyType.Headline3Medium}>
          {copy.bannerCopy}
        </Typography>
      </div>
    </div>
    <div class="flex flex-grow flex-wrap-reverse min-[375px]:flex-nowrap justify-center min-[375px]:justify-end gap-1 min-[375px]:gap-4">
      <Button text on:click={openPreferences}>{copy.bannerPreferencesCopy}</Button>
      <div class="flex gap-1 min-[375px]:gap-4">
        <Button secondary on:click={onDeny}>{copy.bannerDenyCopy}</Button>
        <Button primary on:click={onAccept}>{copy.bannerAcceptCopy}</Button>
      </div>
    </div>
  </div>
{/if}

<style>
  .overlay {
    width: 80%;
    margin: 0 10%;
    border: 1px solid var(--color-grayscale-40);
  }

  @media screen and (max-width: 1023px) {
    .overlay {
      width: calc(100% - 2rem);
      margin: 1rem;
    }
  }
</style>
